import React from 'react';
import CountUp, { useCountUp } from 'react-countup';
//import VisibilitySensor from 'react-visibility-sensor';
var bg_nine = require('../../assets/images/bg.jpeg');
const CounterBlock = (props) => {
	const countUpRef = React.useRef(null);
		useCountUp({
		ref: 'counter',
		end: 1234567,
		enableScrollSpy: true,
		scrollSpyDelay: 1000,
		delay: 1000,
		duration: 5,
	});
    return(
	<>
	{/* <!-- COMPANY STATUS SECTION START --> */}
	<div className="section-full overlay-wraper bg-center bg-cover p-t100 p-b70 site-bg-primary" style={{backgroundImage:`url(${bg_nine})`}}>
		<div className="overlay-main site-bg-primary opacity-09"></div>
		<div className="container summary-counter">
			<div className="row">
				{/* <!-- COLUMNS 1 --> */}
				<div className="col-lg-3 col-md-6 col-sm-6 m-b30">
					<div className="wt-icon-box-wraper left p-a10 text-navy">
						<span className="icon-md">
							<span className="flaticon-happy"></span>
						</span>
						<div className="icon-content">
							<div>		
								<CountUp end={5000} redraw={true} enableScrollSpy>
									{({ countUpRef, start }) => (
										<span>										 
											<h2 className="counter">
												<span ref={countUpRef} className="counter" /><b>+</b>	
											</h2>										 
										</span>
									)}
								</CountUp>							 	
							</div>
							<span className="text-uppercase">Happy Parents</span>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 2 --> */}
				<div className="col-lg-3 col-md-6 col-sm-6 m-b30">
					<div className="wt-icon-box-wraper left p-a10 text-navy">
						<span className="icon-md">
							<span className="flaticon-trophy"></span>
						</span>
						<div className="icon-content">
							<div>
								<CountUp end={50} redraw={true} enableScrollSpy>
									{({ countUpRef, start }) => (
										<span>										 
											<h2 className="counter">
												<span ref={countUpRef} className="counter" /><b>+</b>	
											</h2>										 
										</span>
									)}
								</CountUp>
							</div>
							<span className="text-uppercase">Win Awards</span>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 3 --> */}
				<div className="col-lg-3 col-md-6 col-sm-6 m-b30">
					<div className="wt-icon-box-wraper left p-a10 text-navy">
						<span className="icon-md">
							<span className="flaticon-spa"></span>
						</span>
						<div className="icon-content">							
							<div>
								<CountUp end={30} redraw={true} enableScrollSpy>
									{({ countUpRef, start }) => (
										<span>										 
											<h2 className="counter">
												<span ref={countUpRef} className="counter" /><b>+</b>	
											</h2>										 
										</span>
									)}
								</CountUp>
							</div>
							<span className="text-uppercase">Our Trainer</span>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 4 --> */}
				<div className="col-lg-3 col-md-6 col-sm-6 m-b30">
					<div className="wt-icon-box-wraper left p-a10 text-navy">
						<span className="icon-md">
							<span className="flaticon-team"></span>
						</span>
						<div className="icon-content">							
							<div>
								<CountUp end={2000} redraw={true} enableScrollSpy>
									{({ countUpRef, start }) => (
										<span>										 
											<h2 className="counter">
												<span ref={countUpRef} className="counter" /><b>+</b>	
											</h2>										 
										</span>
									)}
								</CountUp>
							</div>
							<span className="text-uppercase">Happy Students</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	{/* <!-- COMPANY STATUS SECTION END --> */}	
    </>
    )
}
export default CounterBlock;